<template>
  <div id="app" style="margin: 0px; height: 100%">
    <div v-if="status">
      <section><router-view /></section>
    </div>
    <div v-else>
      <div class="sidebar-overlay" v-if="sidebarOpen && isMobile" @click="sidebarOpen = false"></div>

      <div class="sidebar" :class="{
        open: sidebarOpen,
        collapsed: isCollapsed && !isMobile
      }">
        <div class="sidebar-header">
          <header v-show="!isCollapsed || isMobile">ระบบบริหารจัดการ</header>

          <button class="toggle-collapse" @click="toggleSidebar">
            <i class="fa" :class="isMobile
              ? (sidebarOpen ? 'fa-times' : 'fa-bars')
              : (isCollapsed ? 'fa-bars' : 'fa-times')"></i>
          </button>
        </div>

        <ul>
          <li v-if="!currentUser">
            <a href="/login">
              <i class="fa fa-sign-in"></i>
              <span v-show="!isCollapsed || isMobile">เข้าสู่ระบบ</span>
            </a>
          </li>

          <li v-for="m in menu" :key="m.id">
            <a :href="m.url">
              <i class="fa fa-circle"></i>
              <span v-show="!isCollapsed || isMobile">{{ m.name }}</span>
            </a>
          </li>

          <li v-if="currentUser">
            <a href="#" @click.prevent="logOut">
              <i class="fa fa-sign-out"></i>
              <span v-show="!isCollapsed || isMobile">ออกจากระบบ</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="main-content" :class="{ expanded: isCollapsed && !isMobile }">
        <div class="topbar">
          <button class="mobile-menu-btn" @click="sidebarOpen = !sidebarOpen">
            <i class="fa fa-bars"></i>
          </button>
        </div>

        <section>
          <router-view />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
// import Nav from "./components/Nav.vue";
import UserService from "./services/UserService";
import ActivitiesService from "./services/ActivitiesService";

export default {
  name: "App",
  data() {
    return {
      status: true,
      sidebarOpen: false,
      isCollapsed: false,
      isMobile: window.innerWidth <= 768,
      menu: [],
      id: '',
      walk: {},
      hand: {},
      notification_walk: '',
      notification_hand: ''
    };
  },
  components: {
    // Nav,
  },
  mounted() {
    console.log(this.currentUser,'app');
    if (this.$route.fullPath == "/home") {
      this.status = true
    }else{
      this.status = false
    }
    console.log(this.status);
    
    
    window.addEventListener('resize', this.handleResize)
    const key = "device_id";
    this.id = localStorage.getItem(key);
    this.getActivities()
    if (this.id) {
      this.enableNotification()
      this.checkActivityNotification()
    }

    // console.log(this.currentUser,'menu');
    if (this.currentUser) {
      UserService.getMenuByRole(this.currentUser.role).then((res) => {
        // console.log(res.data,'menu_app');
        this.menu = res.data;
        this.status = false
        for (let m = 0; m < res.data.length; m++) {
        //   var cla = "";
          if (res.data[m].url == '/activities_tracking') {
            res.data[m].url = '/activities_tracking/'+this.currentUser.id
        }
      }
      });
    } else {
      this.status = true
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getNotificationMessage(activity, todayKey) {
  if (!activity?.days_of_week || !activity?.no_activity_notification) {
    return "";
  }

  const daysOfWeek = JSON.parse(activity.days_of_week);
  const notifications = JSON.parse(activity.no_activity_notification);

  const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  const activeDays = dayMap.filter(day => daysOfWeek[day]);

  const dayNotificationMap = {};

  activeDays.forEach((day, index) => {
    const notification = notifications.find((n) => n.no === index + 1);
    dayNotificationMap[day] = notification?.message || "";
  });

  return dayNotificationMap[todayKey] || "";
},
checkActivityNotification() {
  let triggered = false;

  setInterval(() => {
    const now = new Date();
    const hour = now.getHours();
    const minute = now.getMinutes();

    if (hour === 9 && minute === 0 && !triggered) {
      triggered = true;

      Promise.all([
        ActivitiesService.getactivity(1),
        ActivitiesService.getactivity(2)
      ]).then(([walkRes, handRes]) => {
        this.walk = walkRes.data;
        this.hand = handRes.data;

        const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        const todayKey = dayMap[new Date().getDay()];

        const walkMessage = this.getNotificationMessage(this.walk, todayKey);
        const handMessage = this.getNotificationMessage(this.hand, todayKey);

        if (walkMessage) {
          this.notification_walk = walkMessage;
          // console.log('walk:', walkMessage);
          this.sendNotification(walkMessage);
        }

        if (handMessage) {
          this.notification_hand = handMessage;
          // console.log('hand:', handMessage);
          this.sendNotification(handMessage);
        }
      }).catch((err) => {
        console.error('โหลดข้อมูล activity ไม่สำเร็จ', err);
      });
    }

    if (minute !== 0) {
      triggered = false;
    }
  }, 1000);
},
    // checkActivityNotification() {
    //   ActivitiesService.getactivity(1).then((res) => {
    //     this.walk = res.data
    //     const activity_walk = this.walk;
    //     ActivitiesService.getactivity(2).then((res) => {
    //     this.hand = res.data
    //     const activity_hand = this.hand
    //     console.log(activity_walk, 'activity1');


    //     const daysOfWeek = JSON.parse(activity_walk.days_of_week);
    //     const notifications = JSON.parse(activity_walk.no_activity_notification);
    //     console.log(daysOfWeek, 'daysOfWeek');

    //     // let triggered = false;


    //     // setInterval(() => {
    //     let now = new Date();
    //     let hour = now.getHours();
    //     let minute = now.getMinutes();
    //     let seconds = now.getSeconds();
    //     console.log(hour, minute, seconds, 'hour, minute', 'seconds');


    //     // if (!daysOfWeek[todayKey]) {
    //     //   return;
    //     // }else{

    //     // if (hour === 10 && minute === 38 && !triggered) {
    //     // triggered = true;

    //     console.log("run at 10:31");
    //     const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    //     const activeDays = dayMap.filter(day => daysOfWeek[day]);

    //     const dayNotificationMap = {};

    //     activeDays.forEach((day, index) => {
    //       const notification = notifications.find(n => n.no === index + 1);
    //       dayNotificationMap[day] = notification?.message || "";
    //     });
    //     const todayKey = dayMap[new Date().getDay()];

    //     const message = dayNotificationMap[todayKey];

    //     if (message) {
    //       console.log(message);
    //     }
    //   });
    //   });

    // },
    async getActivities() {
      await ActivitiesService.getactivity(1).then((res) => {
        this.walk = res.data
        // console.log(this.walk);
        // console.log(res.data.days_of_week);
        // console.log(res.data, 'res.data');
      });
    },
    toggleSidebar() {
      if (this.isMobile) {
        this.sidebarOpen = !this.sidebarOpen
        return
      }
      this.isCollapsed = !this.isCollapsed
    },
    handleResize() {
      this.isMobile = window.innerWidth < 992
      if (this.isMobile) {
        this.sidebarOpen = false
      }
    },
    setActive(id) {
      this.activeMenu = id
      if (this.isMobile) {
        this.sidebarOpen = false
      }
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      setTimeout(function () {
        location.reload();
      }, 500);

      this.$router.push("/");
    },
    async enableNotification() {
      if (!("Notification" in window)) {
        alert("Browser ไม่รองรับ Notification");
        return;
      }

      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          console.log("อนุญาตแจ้งเตือนแล้ว");
        }
      });
    },

    sendNotification(body) {
      if (Notification.permission === "granted") {

        const notification = new Notification("แจ้งเตือนจากระบบ", {
          body: body,
          icon: "https://cdn-icons-png.flaticon.com/512/1827/1827370.png"
        });

        notification.onclick = () => {
          window.focus();
          window.location.href = "/home";
        };

      } else {
        alert("กรุณาอนุญาตการแจ้งเตือนก่อน");
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  font-family: Arial, sans-serif;
}

.app-layout {
  display: flex;
  min-height: 100%;
}

.sidebar {
  width: 250px;
  background: #1f2a44;
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  transition: all 0.3s ease;
  overflow-x: hidden;
  z-index: 1000;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
}

.sidebar.collapsed {
  width: 80px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #162033;
  min-height: 60px;
}

.sidebar header {
  font-size: 20px;
  font-weight: bold;
  white-space: nowrap;
}

.toggle-collapse {
  background: transparent;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar ul li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.sidebar ul li a {
  display: flex;
  align-items: center;
  gap: 12px;
  color: wheat;
  text-decoration: none;
  padding: 14px 20px;
  transition: 0.2s;
  white-space: nowrap;
}

.sidebar ul li a:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.sidebar.collapsed ul li a {
  justify-content: center;
  padding: 14px 0;
}

.main-content {
  margin-left: 250px;
  width: calc(100% - 250px);
  transition: all 0.3s ease;
  min-height: 100vh;
  background: #f4f6fb;
}

.main-content.expanded {
  margin-left: 80px;
  width: calc(100% - 80px);
}

.topbar {
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid #e5e7eb;
}

.mobile-menu-btn {
  display: none;
  background: #1f2a44;
  color: white;
  border: none;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
}

.sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    width: 250px;
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .sidebar.collapsed {
    width: 250px;
  }

  .main-content,
  .main-content.expanded {
    margin-left: 0;
    width: 100%;
  }

  .mobile-menu-btn {
    display: inline-block;
  }
}
</style>